import React, { useContext, useEffect, useState } from 'react'
import api from '../../services/api';
import { FileContext } from '../../context/files';
import 'moment/locale/pt-br';

const TableList = ({ table, financial, update }) => {
    const { get, files, setFiles, getQrCode, getMultiples, getLink, getManualLink, setId, setFileId, setSku, setUserSelectFiles, setEditableFile } = useContext(FileContext)

    const [selectedFiles, setSelectedFiles] = useState([]); // armazena múltiplos selecionados

    const getAll = async () => {
        const response = await api.get("panel/get/all/files")
        setFiles(response.data)
    }

    useEffect(() => {
        console.log(files)
    }, [files])

    useEffect(() => {
        getAll()
    }, [update])

    useEffect(() => {
        get()
    }, [])

    const handleSelectFile = (item) => {
        let updatedSelection;

        if (selectedFiles.find(f => f.id === item.id)) {
            // Se já estava selecionado, remove
            updatedSelection = selectedFiles.filter(f => f.id !== item.id);
        } else {
            // Se não estava, adiciona
            updatedSelection = [...selectedFiles, item];
        }

        setSelectedFiles(updatedSelection);
        setUserSelectFiles(updatedSelection);

        // chama os métodos do contexto sempre baseado no id
        getMultiples(item.file_id, item.category_image, item.uri, item.sku,item.name);
        setSku(item.sku);
        setFileId(item.file_id);
        setId(item.id);
        getQrCode(item.file_id);
        getLink(item.video_uri);
        getManualLink(item.uri);
    }

    const handleFile = (item) => {
        setSku(item.sku);
        setFileId(item.file_id);
        setId(item.id);
        getQrCode(item.file_id);
        getLink(item.video_uri);
        getManualLink(item.uri);
    }

    return (
        <div className='container_startpn_table'>
            <table>
                <thead>
                    <tr>
                        <td>Sku</td>
                        <td>Produto</td>
                        <td>Marca</td>
                        <td className='table_revision'>Revisão</td>
                    </tr>
                </thead>
                <tbody>
                    {files?.map(item => (

                        <tr key={item.id}> {/* aqui agora por id */}
                            <td>
                                <input
                                    className='check_box_mobile'
                                    type='checkbox'
                                    checked={selectedFiles.some(f => f.id === item.id)}
                                    onChange={() => handleSelectFile(item)}
                                />
                                {item.sku}
                            </td>

                            <td
                                onClick={() => handleFile(item)}
                                data-toggle="modal"
                                data-target={!item.name ? "#optionsnoedit" : "#options"}
                                className='table_revision'
                            >
                                {!item.name ? "Personalizado" : item.name}
                            </td>

                            <td
                                onClick={() => handleFile(item)}
                                data-toggle="modal"
                                data-target="#options"
                            >
                                <img
                                    src={item.category_image}
                                    style={{ width: "41px", height: "41px", objectFit: "cover" }}
                                />
                            </td>
                            <td
                                onClick={() => handleFile(item)}
                                data-toggle="modal"
                                data-target="#options"
                                className='table_revision'
                            >
                                {item.revision}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default TableList
